import { action } from "satcheljs";
import { IShiftEntity } from "sh-models";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const shiftsModified = action(
    "SHIFTS_MODIFIED",
    (
        shiftsAdded: IShiftEntity[],
        shiftsDeleted: IShiftEntity[],
        shiftsUpdated: IShiftEntity[],
        viewState?: IPreviewSchedulePageStore  | SchedulesViewStateStore
    ) => ({
        shiftsAdded: shiftsAdded || [],
        shiftsDeleted: shiftsDeleted || [],
        shiftsUpdated: shiftsUpdated || [],
        viewState: viewState
    })
);

export default shiftsModified;
